import routes from "src/routes";
import { matchPath } from "react-router-dom";

// A route with `role_id` is limited to that role (e.g. role_id: 1 = Super Admin), the same
// rule TheSidebar applies to nav items with `role_id`.
const isRoleAllowed = (route, userRoleID) => route.role_id === undefined || route.role_id === userRoleID;

export const canAccessRoute = (routePath, allowedPermission, token, userRoleID) => {
  if (!routePath || !Array.isArray(allowedPermission)) return { allowed: false, type: 'NONE' };

  let matchedRoute = routes.find(route =>
    matchPath(routePath, { path: route.path, exact: route.exact ?? true })
  );

  if (!matchedRoute && routePath.startsWith('/online-help')) {
    matchedRoute = routes.find(route =>
      route.path.startsWith('/online-help') &&
      matchPath(routePath, { path: route.path, exact: false })
    );
  }

  if (!matchedRoute) return { allowed: false, type: 'NONE' };

  const requiredPermission = matchedRoute.permission;

  if (requiredPermission === 'PUBLIC') return { allowed: true, type: 'PUBLIC' };

  if (!isRoleAllowed(matchedRoute, userRoleID)) return { allowed: false, type: 'PROTECTED' };

  if (requiredPermission === 'PASSABLE') return { allowed: !!token, type: 'PASSABLE' };

  const hasPermission = allowedPermission.some(permission => {
    const allPath = permission?.path?.replace(/<([^>]+)>/g, ':$1')?.trim()?.toLowerCase();

    return !!matchPath(requiredPermission.toLowerCase(), { path: allPath, exact: true });
  });

  return { allowed: hasPermission, type: 'PROTECTED' };
};


export const getClosestAllowedRoute = (allowedPermission, userRoleID) => {
  if (!Array.isArray(routes) || routes.length === 0) return null;
  if (!Array.isArray(allowedPermission) || allowedPermission.length === 0) return null;

  for (const permission of allowedPermission) {
    const match = routes.find(route => route.permission && isRoleAllowed(route, userRoleID) && route.permission.toLowerCase() === permission.path?.toLowerCase().trim());
    if (match) {
      return match.path;
    }
  }

  const passableRoute = routes.find(route => route.permission === 'PASSABLE');
  if (passableRoute) {
    return passableRoute.path;
  }

  return null;
};



